// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:24
import { CStampResource_abstract } from './../abstract/SagaSchema/CStampResource_abstract';
export class CStampResource extends CStampResource_abstract {}
